/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Directory_BodyInputs */

const en_features_directory_body = /** @type {(inputs: Features_Directory_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The coach directory in the athlete app shows you to people close by, with free hours straight from your schedule.`)
};

const pl_features_directory_body = /** @type {(inputs: Features_Directory_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog trenerów w aplikacji dla sportowców pokazuje Cię ludziom w pobliżu, z wolnymi godzinami prosto z Twojego grafiku.`)
};

/**
* | output |
* | --- |
* | "The coach directory in the athlete app shows you to people close by, with free hours straight from your schedule." |
*
* @param {Features_Directory_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_directory_body = /** @type {((inputs?: Features_Directory_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Directory_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_directory_body(inputs)
	return en_features_directory_body(inputs)
});